import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUserReviews, getUserReviewsData, getUserReviewsLoading, getUserReviewsError } from '../ducks/userReviews.duck';

/**
 * Custom hook to fetch and manage user reviews
 * @param {string} userId - The user ID to fetch reviews for
 * @param {string} reviewType - Type of reviews to fetch ('provider' or 'customer')
 * @param {number} [deferFetchMs=0] - Delay before fetch (stagger cards on search page)
 * @returns {Object} - Object containing reviews, loading state, and error
 */
export const useUserReviews = (userId, reviewType = 'provider', deferFetchMs = 0) => {
  const dispatch = useDispatch();
  const reviews = useSelector(state => getUserReviewsData(state, userId));
  const loading = useSelector(state => getUserReviewsLoading(state, userId));
  const error = useSelector(state => getUserReviewsError(state, userId));

  useEffect(() => {
    if (!userId) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      dispatch(fetchUserReviews(userId, reviewType));
    }, deferFetchMs);

    return () => clearTimeout(timeoutId);
  }, [dispatch, userId, reviewType, deferFetchMs]);

  return { reviews, loading, error };
}; 